import { matchRoutes } from 'react-router-dom';
import {
    createReactRouterV6DataOptions,
    getWebInstrumentations,
    initializeFaro,
    ReactIntegration,
} from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { generateSessionId } from './faroSession';

const appName = process.env.REACT_APP_NAME ?? '';
const url = process.env.REACT_APP_GRAFANA_URL ?? '';
const environment = process.env.REACT_APP_ENVIRONMENT ?? process.env.NODE_ENV ?? 'production';
const version = process.env.REACT_APP_VERSION ?? '1.0.0';
const enableGrafana = process.env.REACT_APP_ENABLE_GRAFANA_MONITORING === 'true';

const propagateTargets: RegExp[] = [];
if (process.env.REACT_APP_API_URL) propagateTargets.push(new RegExp(process.env.REACT_APP_API_URL));
if (process.env.REACT_APP_ATC_API_URL) propagateTargets.push(new RegExp(process.env.REACT_APP_ATC_API_URL));

if (!enableGrafana) {
    // eslint-disable-next-line no-console
    console.info('Grafana Faro monitoring is disabled (REACT_APP_ENABLE_GRAFANA_MONITORING is not true)');
} else if (!appName || !url) {
    // eslint-disable-next-line no-console
    console.warn('Faro not initialised: REACT_APP_NAME and REACT_APP_GRAFANA_URL must be set');
} else {
    initializeFaro({
        url,
        app: { name: appName, version, environment },
        instrumentations: [
            ...getWebInstrumentations({ captureConsole: true }),
            new TracingInstrumentation({
                instrumentationOptions: {
                    propagateTraceHeaderCorsUrls: propagateTargets,
                },
            }),
            new ReactIntegration({
                router: createReactRouterV6DataOptions({ matchRoutes }),
            }),
        ],
        consoleInstrumentation: {
            consoleErrorAsLog: true,
        },
        sessionTracking: {
            enabled: true,
            // Survive a mid-test refresh (session stored in localStorage).
            persistent: true,
            // 4h max lifetime to cover a long test including idle gaps.
            maxSessionPersistenceTime: 4 * 60 * 60 * 1000,
            // Readable session ID format; see faroSession.ts.
            generateSessionId,
            // Initial stage; flipped by faroSession helpers as the user
            // moves through pre-login → authenticated → precheck → test → end.
            session: {
                attributes: { stage: 'pre-login' },
            },
        },
        ignoreErrors: [
            /^ResizeObserver loop limit exceeded$/,
            /^ResizeObserver loop completed with undelivered notifications$/,
            /^Script error\.$/,
            /chrome-extension:\/\//,
            /moz-extension:\/\//,
        ],
    });
}
